import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, intlShape } from 'react-intl'
import { AIRDNA_QUALITY, AIRDNA_FREQUENCY } from 'src/constants/messages'
import Text from 'src/Components/shared/Text'
import FormField from 'src/Components/shared/FormField'
import PricePerNight from 'src/Components/shared/PricePerNight'

import Slider from 'src/Components/shared/Slider'
import styles from './ChartControls.module.scss'

const propTypes = {
  intl: intlShape,
  nightsPerMonth: PropTypes.number,
  pricePerNight: PropTypes.number,
  paymentMax: PropTypes.number,
  rentalNightMax: PropTypes.number,
  updateSetting: PropTypes.number
}

const SliderDescription = props => (
  <Text size='xs' color='quiet' align='center' {...props} />
)

const ChartControls = ({
  intl,
  nightsPerMonth,
  pricePerNight,
  paymentMax,
  rentalNightMax,
  updateSetting
}) => {
  return (
    <div className='columns columns--spaced'>
      <div className={`col slider-container ${styles.sliderContainer}`}>
        <FormField
          name='pricePerNight'
          input={Slider}
          labelText={SliderDescription}
          onChange={updateSetting}
          value={pricePerNight}
          min={25}
          max={paymentMax}
          minPhrase={intl.formatMessage(AIRDNA_QUALITY.basic)}
          maxPhrase={intl.formatMessage(AIRDNA_QUALITY.fancy)}
          step={1}
          valueFormat={PricePerNight}
        >
          <FormattedMessage
            id='AirDna.slider.pricePerNight'
            defaultMessage='How nice would you make it?'
          />
        </FormField>
      </div>
      <div className={`col slider-container ${styles.sliderContainer}`}>
        <FormField
          name='nightsPerMonth'
          input={Slider}
          labelText={SliderDescription}
          onChange={updateSetting}
          value={nightsPerMonth}
          min={1}
          max={rentalNightMax}
          minPhrase={intl.formatMessage(AIRDNA_FREQUENCY.seldom)}
          maxPhrase={intl.formatMessage(AIRDNA_FREQUENCY.often)}
          step={1}
        >
          <FormattedMessage
            id='AirDna.slider.nightsPerMonth'
            defaultMessage='Nights per month you‘d rent'
          />
        </FormField>
      </div>
    </div>
  )
}

ChartControls.propTypes = propTypes

export default ChartControls
